export const setToken = (state, payload) => {
  state.tokenYE = payload
}
